import React, { FC } from 'react';
import { MaterialIcon } from '../material-icon/MaterialIcon';
import styles from './system_button.module.scss';

export const SystemButtonContent: FC<{
  iconRight?: string;
  iconLeft?: string;
}> = ({ iconRight = '', children, iconLeft = '' }) => (
  <>
    {iconLeft && <MaterialIcon name={iconLeft} className={styles.iconLeft} />}
    {children}
    {iconRight && (
      <MaterialIcon name={iconRight} className={styles.iconRight} />
    )}
  </>
);
